<div class="Dialog" mat-dialog-content>
  <div>
    <p>{{ dialogData }}</p>
  </div>
  <div class="Flexbox Align--center Buttons Gap--smaller">
  </div>
</div>